/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   11/11/21
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {EmployeesFilter} from "../../interfaces/Global";
import {persistState} from "../helpers";

export type EmployeesFilterState = EmployeesFilter;

const STORAGE_KEY = 'vega.state.employees-filter';
const storedState = localStorage.getItem(STORAGE_KEY);
const initialState: EmployeesFilterState = storedState ? JSON.parse(storedState) : [];

export const slice = createSlice({
	name: 'employees-filter',
	initialState,
	reducers: {
		set: (state, action: PayloadAction<EmployeesFilterState>) => {
			const newState = action.payload;
			persistState(STORAGE_KEY, newState);
			return newState;
		},
	},
});

export const { set } = slice.actions;
export default slice.reducer;